import { ref } from 'vue'

/** Estado compartido: un solo ref para que header, sidebar y demás se sincronicen */
const isDark = ref(false)

let initialized = false
let mediaListenerAttached = false

function updateHTML () {
  if (typeof document === 'undefined') return
  if (isDark.value) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
}

function attachSystemPreferenceListener () {
  if (mediaListenerAttached || typeof window === 'undefined') return
  mediaListenerAttached = true
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  mediaQuery.addEventListener('change', (e) => {
    if (!localStorage.getItem('theme')) {
      isDark.value = e.matches
      updateHTML()
    }
  })
}

function initTheme () {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  const savedTheme = localStorage.getItem('theme')
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

  isDark.value = savedTheme === 'dark' || (!savedTheme && prefersDark)
  updateHTML()
  attachSystemPreferenceListener()
}

function toggleTheme () {
  initTheme()
  isDark.value = !isDark.value
  localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
  updateHTML()
}

export function useTheme () {
  initTheme()

  return {
    isDark,
    toggleTheme
  }
}
